let backendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'localhost') {
    backendHost = 'http://localhost:8080';
} else if (hostname === 'order.equals.thewebpeople.ca') {
    backendHost = 'https://order.equals.thewebpeople.ca';
} else {
    backendHost = 'https://order.equalsbrewing.com';
}

export const API_ROOT = `${backendHost}/api`;